import { DownloadOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Modal, message } from "antd";
import type { Dayjs } from "dayjs";
import type React from "react";
import { useExportReservations } from "../hooks";

interface ReservationExportModalProps {
	open: boolean;
	onClose: () => void;
	eventOccasionId: number;
	eventTitle?: string;
	primaryColor?: string;
	primaryLightColor?: string;
}

export const ReservationExportModal: React.FC<ReservationExportModalProps> = ({
	open,
	onClose,
	eventOccasionId,
	eventTitle = "",
	primaryColor = "#99CA29",
	primaryLightColor = "#fdfff0",
}) => {
	const [form] = Form.useForm();
	const exportMutation = useExportReservations();

	const handleExport = async (values: { dateRange?: [Dayjs, Dayjs] }) => {
		try {
			const startDate = values.dateRange?.[0]?.format("YYYY-MM-DD");
			const endDate = values.dateRange?.[1]?.format("YYYY-MM-DD");

			await exportMutation.mutateAsync({
				eventOccasionId,
				startDate,
				endDate,
				format: "csv",
			});

			message.success("予約リストをダウンロードしました");
			onClose();
		} catch (error) {
			if (error instanceof Error) {
				message.error(error.message);
			} else {
				message.error("ダウンロードに失敗しました");
			}
		}
	};

	return (
		<Modal
			open={open}
			onCancel={onClose}
			title="予約リストCSVダウンロード"
			footer={null}
			width={500}
			centered
			destroyOnClose
		>
			<Form form={form} layout="vertical" size="large" onFinish={handleExport}>
				{eventTitle && (
					<div
						style={{
							padding: "12px 16px",
							backgroundColor: primaryLightColor,
							borderRadius: 4,
							marginBottom: 16,
							textAlign: "center",
						}}
					>
						<span style={{ fontWeight: "bold", color: primaryColor }}>
							{eventTitle}
						</span>
					</div>
				)}

				<Form.Item name="dateRange" label="期間（任意）">
					<DatePicker.RangePicker
						style={{ width: "100%" }}
						placeholder={["開始日", "終了日"]}
					/>
				</Form.Item>

				<div
					style={{
						display: "flex",
						justifyContent: "center",
						gap: 16,
						marginTop: 24,
					}}
				>
					<Button
						type="primary"
						htmlType="submit"
						icon={<DownloadOutlined />}
						loading={exportMutation.isPending}
						style={{
							backgroundColor: primaryColor,
							borderColor: primaryColor,
						}}
					>
						ダウンロード
					</Button>
					<Button onClick={onClose}>キャンセル</Button>
				</div>
			</Form>
		</Modal>
	);
};
